import React, { useEffect, useState } from "react";
import BlogHero from "../components/BlogHero";
import BlogCard from "../components/BlogCard";
import "./Blog.css";

const Blog = ({ isDarkMode }) => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch("https://astrasighttech.com/api/index.php")
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error("Failed to fetch blogs");
        }

        return data;
      })
      .then((data) => {
        setBlogPosts(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <BlogHero
        title="Our Blog"
        subtitle="Insights, updates, and stories from Astrasight"
        isDarkMode={isDarkMode}
      />

      {/* FULL-WIDTH SECTION (BACKGROUND CONTROL) */}
      <section className={`blog-list ${isDarkMode ? "dark" : ""}`}>
        {/* INNER CONTAINER (WIDTH + GRID CONTROL) */}
        <div className="blog-list-inner">
          {loading && <p className="status-text">Loading blogs...</p>}
          {error && <p className="error">{error}</p>}

          {!loading && !error && blogPosts.length === 0 && (
            <p className="status-text">No blog posts yet.</p>
          )}

          {!loading &&
            !error &&
            blogPosts.map((post) => (
              <BlogCard
                key={post.id || post.slug}
                post={post}
                isDarkMode={isDarkMode}
              />
            ))}
        </div>
      </section>
    </>
  );
};

export default Blog;
